import { axiosClient } from "@/shared/api/axios-client";
import type { MensajeDeChat } from "@/lib/types";

/**
 * API del chat solicitante ↔ autorizador. Bidireccional, persistente ·
 * solo texto plano (decisión 36). El listar lo consumen tanto la
 * `ChatCard` (con polling) como el badge "N mensajes" en los tabs.
 */
export const chatApi = {
  listar: (solicitudId: string) =>
    axiosClient
      .get<MensajeDeChat[]>(`/api/solicitudes/${solicitudId}/chat`)
      .then((r) => r.data),

  enviar: (solicitudId: string, texto: string) =>
    axiosClient
      .post<MensajeDeChat>(`/api/solicitudes/${solicitudId}/chat`, { texto })
      .then((r) => r.data),
};
